export default (r: __WebpackModuleApi.RequireContext) => {
  let images: any = {};
  r.keys().map((item, index) => {
    images[item.replace("./", "")] = r(item);
  });
  return images;
};
